import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Snackbar,
  Alert,
} from "@mui/material";
import { getData } from "../../../../services/library";
import SelectorDePrecios from "./SelectorDePrecios";
import { UrlApi } from "../../../../services/apirest";
import DefinicionVariable from "./DefinicionVariable";
import moment from "moment/moment";

function ActualizarPrecios({ open, setOpen, onClose, lista }) {
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [step, setStep] = useState(1);
  const [sucursales, setSucursales] = useState([]);
  const [productos, setProductos] = useState([]);
  const [sucursalesSeleccionadas, setSucursalesSeleccionadas] = useState([]);
  const [productosSeleccionados, setProductosSeleccionados] = useState([]);
  const [monto, setMonto] = useState("");
  const [porcentaje, setPorcentaje] = useState("");
  const [precioMinimo, setPrecioMinimo] = useState("");
  const [precioMaximo, setPrecioMaximo] = useState("");
  const [tipoOperacion, setTipoOperacion] = useState("");
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [guardando, setGuardando] = useState(false);
  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    handleClose();
  };

  useEffect(() => {
    getData("/sucursales/xsucauth/"+localStorage.getItem("suc_auth").split(","), (data) => setSucursales(data));
    getData("/productos/envasados", (data) => setProductos(data));
  }, []);

  const handleClose = () => {
    onClose(false);
  };

  const handleNext = () => {
    if (
      sucursalesSeleccionadas.length === 0 ||
      productosSeleccionados.length === 0
    ) {
      setNotificacion({
        open: true,
        mensaje: "Debe seleccionar al menos una sucursal y un producto",
        severity: "warning",
        color: "warning",
      });
      return;
    }
    setStep(2);
  };

  const handleBack = () => setStep(1);

  const validarInput = (value) => /^-?\d*\.?\d*$/.test(value);

  const handleMontoChange = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setMonto(value);
      if (value !== "") setPorcentaje("");
      setTipoOperacion("monto");
    }
  };

  const handlePorcentajeChange = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setPorcentaje(value);
      if (value !== "") setMonto("");
      setTipoOperacion("porcentaje");
    }
  };

  const handlePrecioMinimo = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setPrecioMinimo(value);
      if (value !== "") setMonto("");
      setTipoOperacion("precio");
    }
  };

  const handlePrecioMaximo = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setPrecioMaximo(value);
      if (value !== "") setMonto("");
      setTipoOperacion("precio");
    }
  };

  const handleActualizarPrecios = async (e) => {
    e.preventDefault();
    setGuardando(true);
    const valor = parseFloat(monto || porcentaje);

    const listaFiltrada = lista.filter(
      (item) =>
        sucursalesSeleccionadas.some((s) => s.id === item.sucursal) &&
        productosSeleccionados.some((p) => p.idproducto === item.producto),
    );

    const listaActualizada = listaFiltrada.map((item) => {
      let nuevoMin = item.precio_minimo;
      let nuevoMax = item.precio_maximo;

      if (tipoOperacion === "monto") {
        nuevoMin += valor;
        nuevoMax += valor;
      } else if (tipoOperacion === "porcentaje") {
        const factor = valor / 100;
        nuevoMin += nuevoMin * factor;
        nuevoMax += nuevoMax * factor;
      } else {
        nuevoMin = precioMinimo;
        nuevoMax = precioMaximo;
      }

      return {
        id: item.id,
        precio_minimo: Math.round(nuevoMin),
        precio_maximo: Math.round(nuevoMax),
        usuario: localStorage.getItem("user"),
      };
    });

    try {
      const res = await fetch(UrlApi + "/envasado_rango_precios/multiple/", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(listaActualizada),
      });
      const data = await res.json();

      if (!data.err) {
        //  Armo historial
        const historial = listaFiltrada.map((item, index) => {
          const actualizado = listaActualizada[index];
          return {
            producto: item.producto,
            sucursal: item.sucursal,
            precio_minimo_anterior: item.precio_minimo,
            precio_maximo_anterior: item.precio_maximo,
            precio_minimo_nuevo: actualizado.precio_minimo,
            precio_maximo_nuevo: actualizado.precio_maximo,
            fecha: moment().format("YYYY-MM-DD"),
            usuario: localStorage.getItem("user"),
          };
        });

        // Guardo historial
        await guardarHistorial(historial);

        setOpenSnack(true);
        setColorMensaje("#D4EFDF");
        setMensaje("La variación se guardó exitosamente !");
      } else {
        console.error("Error al actualizar precios", data.err);
      }
    } catch (err) {
      console.error("Error en actualización", err);
    } finally {
      setGuardando(false);
    }
  };

  const guardarHistorial = async (historial) => {
    try {
      const resp = await fetch(`${UrlApi}/envasado_historial_rango/multiple`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(historial),
      });

      const data = await resp.json();
      if (!data.err) {
        console.log("Historial guardado correctamente");
      } else {
        console.error("Error guardando historial", data.err);
      }
    } catch (error) {
      console.error("Error en fetch historial:", error);
    }
  };

  const isPrecioMinMaxValido = precioMinimo !== "" && precioMaximo !== "";
  const isMontoOPorcentajeValido =
    (monto !== "" || porcentaje !== "") && !isPrecioMinMaxValido;

  const listasDisabled =
    productosSeleccionados.length === 0 || sucursalesSeleccionadas.length === 0;
  const isGuardarDisabled =
    openSnack ||
    guardando ||
    (!isPrecioMinMaxValido && !isMontoOPorcentajeValido);

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth={"xl"}>
        <form
          onSubmit={handleActualizarPrecios}
          style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}
        >
          <Box bgcolor="#1F618D">
            <DialogTitle
              sx={{
                bgcolor: "#1F618D",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                position: "relative",
                p: 1,
              }}
            >
              <Typography
                variant="h6"
                component="div"
                sx={{
                  flexGrow: 1,
                  textAlign: "center",
                  pr: 4,
                }}
              >
                Actualizar Precios - Paso {step}
              </Typography>
            </DialogTitle>
          </Box>

          <DialogContent sx={{ p: 1.8 }}>
            <Stepper activeStep={step - 1} alternativeLabel>
              <Step>
                <StepLabel>Seleccionar Sucursales y Productos</StepLabel>
              </Step>
              <Step>
                <StepLabel>Ingresar variación</StepLabel>
              </Step>
            </Stepper>
            {step === 1 && (
              <>
                <SelectorDePrecios
                  productos={productos}
                  sucursales={sucursales}
                  sucursalesSeleccionadas={sucursalesSeleccionadas}
                  setSucursalesSeleccionadas={setSucursalesSeleccionadas}
                  productosSeleccionados={productosSeleccionados}
                  setProductosSeleccionados={setProductosSeleccionados}
                />
              </>
            )}

            {/* Campos de Precio */}
            {step === 2 && (
              <DefinicionVariable
                monto={monto}
                porcentaje={porcentaje}
                precioMinimo={precioMinimo}
                precioMaximo={precioMaximo}
                handleMontoChange={handleMontoChange}
                handlePorcentajeChange={handlePorcentajeChange}
                handlePrecioMinimo={handlePrecioMinimo}
                handlePrecioMaximo={handlePrecioMaximo}
              />
            )}
          </DialogContent>

          <DialogActions
            sx={{
              justifyContent: "space-between",
              p: 1,
              position: "sticky",
              bottom: 0,
            }}
          >
            <Button
              color="error"
              variant="contained"
              onClick={step === 1 ? handleClose : handleBack}
              sx={{ minWidth: 120 }}
            >
              Volver
            </Button>
            {step === 1 && (
              <Button
                disabled={listasDisabled}
                variant="contained"
                color="primary"
                onClick={handleNext}
              >
                Siguiente
              </Button>
            )}
            {step === 2 && (
              <Button
                color="success"
                type="submit"
                variant="contained"
                sx={{ minWidth: 120 }}
                disabled={isGuardarDisabled}
              >
                Confirmar
              </Button>
            )}
          </DialogActions>
        </form>
      </Dialog>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default ActualizarPrecios;
